module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "team-presence-table do-scroller__container"
  }, [_c('div', {
    staticClass: "do-scroller do-scroller-max-height"
  }, [_c('table', {
    staticClass: "team-presence-table__table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "team-presence-table__col-name"
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['employee']))]), _vm._v(" "), _c('th', {
    staticClass: "team-presence-table__col-total"
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['week_total']))]), _vm._v(" "), _vm._l((_vm.weekDays), function(day) {
    return _c('th', {
      key: day.format('YYYY-MM-DD'),
      staticClass: "team-presence-table__col-day"
    }, [_c('span', {
      staticClass: "team-presence-table__day-name"
    }, [_vm._v(_vm._s(_vm.formatDayName(day)))]), _vm._v(" "), _c('span', {
      staticClass: "team-presence-table__day-date"
    }, [_vm._v(_vm._s(_vm.formatDayDate(day)))])])
  })], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.tableRows), function(row) {
    return _c('tr', {
      key: row.calendarId,
      staticClass: "team-presence-table__row"
    }, [_c('td', {
      staticClass: "team-presence-table__col-name"
    }, [_vm._v(_vm._s(row.name))]), _vm._v(" "), _c('td', {
      staticClass: "team-presence-table__col-total"
    }, [_vm._v(_vm._s(row.weekTotal))]), _vm._v(" "), _vm._l((_vm.weekDays), function(day) {
      return _c('td', {
        key: row.calendarId + '-' + day.format('YYYY-MM-DD'),
        staticClass: "team-presence-table__col-day"
      }, _vm._l((row.slotsByDay[day.format('YYYY-MM-DD')]), function(slot, idx) {
        return _c('div', {
          key: row.calendarId + '-' + day.format('YYYY-MM-DD') + '-' + idx,
          staticClass: "team-presence-table__slot"
        }, [_vm._v("\n            " + _vm._s(slot) + "\n          ")])
      }), 0)
    })], 2)
  }), 0)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9a9eba8a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TeamCalendar/TeamCalendarPresenceTable.vue
// module id = 2066
// module chunks = 1